import React from 'react';
import { FaInstagram, FaWhatsapp, FaLinkedin, FaSpotify } from 'react-icons/fa';
import './Footer.css'

const Footer = ({ t }) => {
  return (
    <footer id='footer'>
      <ul className="permalinks">
        <li><a href="#root">{t('footer-anchor1')}</a></li>
        <li><a href="#about">{t('footer-anchor2')}</a></li>
        <li><a href="#experience">{t('footer-anchor3')}</a></li>
        <li><a href="#services">{t('footer-anchor4')}</a></li>
        <li><a href="#portfolio">{t('footer-anchor5')}</a></li>
        <li><a href="#testimonials">{t('footer-anchor6')}</a></li>
        <li><a href="#contact">{t('footer-anchor7')}</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.linkedin.com/in/rafael-permec/"><FaLinkedin /></a>
        <a href="https://www.instagram.com/o.perdigao/"><FaInstagram /></a>
        <a href="https://wa.me/5531987748874"><FaWhatsapp /></a>
        <a href="https://open.spotify.com/user/12142389777"><FaSpotify /></a>
      </div>
      <div className="footer__copyright">
        <small>{t('footer-text1')}</small>
        <br />
        {/* <small>{t('footer-text2')}</small> */}
      </div>
    </footer>
  )
}

export default Footer;
